import { Alert, Collapse, IconButton } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { StyledSuccessAlert, StyledErrorAlert } from "../styles/HomeStyles";

export const CustomAlert = ({ alert, setAlert }) => {
  return (
    <Collapse in={alert.open}>
      {alert.type === "success" ? (
        <StyledSuccessAlert
          variant="filled"
          icon={<CheckCircleIcon fontSize="inherit" />}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setAlert({ ...alert, open: false });
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          {alert.text}
        </StyledSuccessAlert>
      ) : (
        <StyledErrorAlert
          variant="filled"
          icon={<ErrorIcon fontSize="inherit" />}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setAlert({ ...alert, open: false });
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          {alert.text}
        </StyledErrorAlert>
      )}
    </Collapse>
  );
};
